export default {
  attachmentItemComponent: 'attachment-item-pill',
  allowMediaInserter: false,
  allowMention: false,
  allowAttribute: false,
  autoFocusBottomRight: false,
  autoFocusTopLeft: false,
  urlReplacement: false,
  allowImage: true,
  allowButton: false,
  allowVideo: true,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  recoverErrors: true,
  allowEmoji: true,
  allowSavedReplies: true,
  allowMarkdownHeadings: false,
  markdownInlineCode: true,
  stripEmptyTrailingBlocks: true
};